import get from 'lodash/get';

export function getFeatureFlag (subscription, flag) {
    return !!get(subscription, `featureFlags.${flag}`, false);
}

export function subIsInTrial (subscription) {
    return get(subscription, 'isInTrial', false);
}

export function getTrialEndDate (subscription) {
    return get(subscription, 'trialEndDate', 0);
}

export function getSubPlan (subscription) {
    if (getFeatureFlag(subscription, 'pendoFree')) {
        return 'free';
    }
    if (getFeatureFlag(subscription, 'starterPackage')) {
        return 'starter';
    }
    if (getFeatureFlag(subscription, 'starter2024Package')) {
        return 'starter2024';
    }

    return 'engage';
}

export function subIsDefaultPlan (subscription) {
    return getSubPlan(subscription) === 'engage' && !subIsInTrial(subscription);
}
